module.exports = __webpack_public_path__ + "static/header-image-02-aab476b7b3060e9ae7754eb5687ab2e6.png";